
$.fn.createSVG = function()
{	
	$(this).each(function () 
	{
	    var $img = $(this);
	    var imgID = $img.attr('id');
	    var imgClass = $img.attr('class');
	    var imgURL = $img.attr('src');
	    var imgStyles = $img.attr('style');
	    var imgAlt = $img.attr('alt');

	    $.get(imgURL, function (data) {
	        // Get the SVG tag, ignore the rest
	        var $svg = $(data).find('svg');

	        // Add replaced image's ID to the new SVG
	        if (typeof imgID !== 'undefined') {
	            $svg = $svg.attr('id', imgID);
	        }
	        // Add replaced image's classes to the new SVG
	        if (typeof imgClass !== 'undefined') {
	            $svg = $svg.attr('class', imgClass + ' replaced-svg');
	        }

	        if (typeof imgStyles !== 'undefined') {
	            $svg = $svg.attr('style', imgStyles);
	        }

	        if (typeof imgAlt !== 'undefined') {
	            $svg = $svg.attr('alt', imgAlt);
	            $svg = $svg.attr('title', imgAlt);
	        }

	        // Remove any invalid XML tags as per http://validator.w3.org
	        $svg = $svg.removeAttr('xmlns:a');

	        // Check if the viewport is set, else we gonna set it if we can.
	        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
	        }

	        $svg.attr('src', imgURL);

	        // Replace image with new SVG
	        $img.replaceWith($svg);
	    }, 'xml');
	});
	
	return this;
};

$.fn.owlCarouselStart = function(index)
{
		this.find('img:not(.lazy)').each(function()
		{
			if($(this).attr('data-original'))
			{
				$(this).attr('src',$(this).attr('data-original'));
				$(this).removeAttr('data-original');
			}
		});

		this.addClass('owl-carousel');//.addClass('mx-0');
		this.find('.fluid-t').addClass('fluid-t_').removeClass('fluid-t');

		var classList = this.find('> div').eq(0).attr('class').split(/\s+/);
		var cols = {};

		for (var i = 0; i < classList.length; i++) 
		{
			if(classList[i].indexOf('col-xl') >= 0)
			{
				cols['1200'] = new Array;
				cols['1200']['items'] = (12 / parseInt(classList[i].replace(/col-xl-/g,"")));
				this.find('> div').removeClass(classList[i]);
			}
			else if(classList[i].indexOf('col-lg') >= 0)
			{
				cols['992'] = new Array;
				cols['992']['items'] = (12 / parseInt(classList[i].replace(/col-lg-/g,"")));
				this.find('> div').removeClass(classList[i]);
			}
			else if(classList[i].indexOf('col-md') >= 0)
			{
				cols['768'] = new Array;
				cols['768']['items'] = (12 / parseInt(classList[i].replace(/col-md-/g,"")));
				this.find('> div').removeClass(classList[i]);
			}
			else if(classList[i].indexOf('col-sm') >= 0)
			{
				cols['576'] = new Array;
				cols['576']['items'] = (12 / parseInt(classList[i].replace(/col-sm-/g,"")));
				this.find('> div').removeClass(classList[i]);
			}
			else if(classList[i].indexOf('col-') >= 0)
			{
				cols['0'] = new Array;
				cols['0']['items'] = (12 / parseInt(classList[i].replace(/col-/g,"")));
				this.find('> div').removeClass(classList[i]);
			}
		}

		this.find('> div').addClass('px-2');

		var margin = !this.attr('data-margin') ? 0 : parseInt(this.attr('data-margin'));
		var nav = (typeof this.attr('data-nav') === 'undefined') ? false : true;
		var dots = (typeof this.attr('data-dots') === 'undefined') ? false : true;
		var loop = (typeof this.attr('data-loop') === 'undefined') ? false : true;
		var autoplay = (typeof this.attr('data-autoplay') === 'undefined') ? false : true;
		var t = this;
		var dotsContainer = false;

		if(this.parent().find('.dots-container').length && dots)
		{
			this.parent().find('.dots-container').attr('id','carousel-dots-' + index);
			dotsContainer = '#carousel-dots-' + index;
		}

		this.owlCarousel(
		{
			loop: loop,
			nav: nav,
			dots: dots,
			autoplay: autoplay,
			margin: margin,
			responsive: cols,
			dotsContainer: dotsContainer,
			autoplayTimeout: 8000,
			onInitialized: function()
			{
				t.find('.fluid-t_').addClass('fluid-t').removeClass('fluid-t_');
			}
		});
		
		return this;
};

$.fn.parallax = function(resistance, mouse) 
{
	$el = $(this);
	TweenLite.to($el, 0.2, 
	{
		x: -((mouse.clientX - window.innerWidth / 2) / resistance),
		y: -((mouse.clientY - window.innerHeight / 2) / resistance)
	});
};

$.fn.callbackOption = function(option,params)
{
	switch(option)
	{
		case 'menu':
			$('#menuMod').modal();
			break;

		case 'change-input':
			$(this).parent().find('> *:not(.call-js)').addClass('d-none');
			$(this).parent().find('> .form-group').removeClass('d-none');
			break;

		case 'toggle-blocks':
			if($(this).attr('data-block-hide'))
				$('.' + $(this).attr('data-block-hide')).addClass('d-none');
 
			if($(this).attr('data-block-show'))
				$('.' + $(this).attr('data-block-show')).removeClass('d-none');
			break;

		case 'set-avatar':
			$('img.avatar').attr('src',baseurl + params.path + '?' + Math.floor(Math.random() * Math.floor(1000000)));

			break;

		case 'appendFile':
			var html = '';

			html+= '<div class="d-inline-block mr-3 mb-3 font-size-80">';
			html+= '	<input type="hidden" name="files[]" value="' + params.path + '">';
			html+= '	<span class="border-bottom mr-1">' + params.name + '</span>';
			html+= '	<sup class="font-size-80 text-red"><a href="#" class="call-js" data-option="rm-file">x</a></sup>';
			html+= '</div>';


			$('.files-container').append(html);

			break;
			
		/*case 'сancellations':
			var id = $(this).closest('.open_dialog_chat').attr('rel2');
			$.ajax({
				type: 'POST',
				method: 'POST',
				cashe: false,
				url: baseurl + 'checkout',
				data: { ajax: true, 
					   	option: '', 
					   	id: id, 
					   	depay: 'depay'  
					   }
			}).done(function (msg) {
	
			});
			break;*/ 

		case 'rm-file':
			$(this).parent().parent().remove();
			break;
	}

	console.log(option);
};

$.fn.message = function(text)
{
	$('#messageMod .message').html(text);
	$('#messageMod').modal();

	return this;
};

$(function()
{
	$('a[href="#"], .call-js').click(function(e)
	{
		e.preventDefault();
	});

	$('body').on('change', '.uploadFile', function()
	{

		var form_data = new FormData();

		var t = $(this);

		if($(this).prop('files').length < 1)
			return;

		var uploaded = 0;
		var count_files = $(this).prop('files').length;

		$('body').addClass('loading');

		for (var i = 0; i < $(this).prop('files').length; i++) 
		{
			// console.log($(this).prop('files')[i].name);

			form_data.append('Filedata', $(this).prop('files')[i]);
			form_data.append('user', user);
			form_data.append('timestamp', timestamp);
			form_data.append('token', token);
		
			if(t.attr('data-size'))
				form_data.append('size', t.attr('data-size'));
			
			if(t.attr('data-folder'))
				form_data.append('folder', t.attr('data-folder'));

			if(t.attr('data-filename'))
			{
				if(t.attr('data-filename') == 'original')
					form_data.append('filename', $(this).prop('files')[i].name);
				else
					form_data.append('filename', t.attr('data-filename'));
			}

			// var l = getRandomInt(1,1000000);

			console.log(form_data);

			$.ajax(
			{
				url: baseurl + 'upload', // point to server-side PHP script 
				dataType: 'text',  // what to expect back from the PHP script, if anything
				cache: false,
				contentType: false,
				processData: false,
				data: form_data,                         
				type: 'post',
				method: 'post',

				success: function(php_script_response)
				{
					var result = $.parseJSON( php_script_response );

					if(t.attr('data-callback'))
						t.callbackOption(t.attr('data-callback'),result);

					$('body').removeClass('loading');

				    console.log(result); // display response from the PHP script, if any
				}
			});
		}

		
	});
});

$( window ).load(function()
{
	$('form').each(function(index)
	{
		$('[name="agree"]',this).attr('id','agree_' + index);
		$('[name="agree"]',this).next().attr('for','agree_' + index);
	});

	$('body').on('click','.call-js',function(e)
	{
		e.preventDefault();

		var t = $(this);
		var option = !t.attr('data-option') ? 'form' : t.attr('data-option');

		$(this).callbackOption(option);
	});

	// load убрать в боевой версии

	// var i = 0;
	// $('[data-mod]').each(function()
	// {
		$(this).load(baseurl + $(this).attr('data-mod') + '.mod?' + new Date().getTime(), function()
		{
			// i++;

			// если все блоки загружены
			// if(i == $('[data-mod]').length)
			// {
				$.getScript(baseurl + 'scripts/bootstrap.min.js', function()
				{
					if($.trim($('#messageMod .message').text()).length)
						$('#messageMod').modal();

					// $(window).message('Привет, человек!');
					// $('#menuMod').modal();

					$( "#bookingMod" ).on('shown.bs.modal', function (e)
					{
						var btn = $(e.relatedTarget);
						var params = btn.attr('data-params') ? $.parseJSON(btn.attr('data-params')) : [];

						$.each( params, function( key, value ) 
						{
							$( "#bookingMod" ).find('input[name="' + key + '"]').val(value);
						});
					});


					$( "#paykeeperMod" ).on('shown.bs.modal', function (e)
					{
						var btn = $(e.relatedTarget);
						var params = btn.attr('data-params') ? $.parseJSON(btn.attr('data-params')) : [];

						$.each( params, function( key, value ) 
						{
							$( "#paykeeperMod" ).find('input[name="' + key + '"]').val(value);
						});
					});
					

					$('body').on('focus', '.form-control', function (e)
					{
						$(this).removeClass('has-error');
						$(this).parent().find('.label-info').remove();
					});

					$('input[name="agree"]').change(function()
					{
						if($(this).is(":checked"))
						{
							$(this).addClass('has-error');
							$(this).parent().find('span.bg-red').remove();
						}
					});

					$('body').on('submit', 'form', function (e) 
					{
						var error = 0;
						var text = '';

						var form = $(this);

						$('.required:enabled,.r:enabled', this).each(function () 
						{
							if ($(this).attr('id') == 'agree' && !$(this).is(":checked")) 
							{
								$(window).message('<p class="h1 font-weight-600 mb-4">Внимание</p><div>Для продолжения необходимо принять условия обработки персональных данных.</div>');
									error++;
							}
							
							if ($(this).val().length < 1) 
							{
								var name = $(this).attr('name');
								var id = $(this).attr('id');

								if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';

								var tagname = $(this).prop("tagName");
								$(this).addClass('has-error');

								var error_text = '<span class="bg-red font-size-80 text-white d-inline-block px-2 py-1 rounded-3 label-info">Это поле заполнено неверно!</span>';

								$(error_text).insertAfter(this);

								if (tagname == 'SELECT') {
									var select_id = $(this).attr('id') + '_chosen';
									$('#' + select_id + '.chosen-container').addClass('invalid');
								}
								error++;
							} 
							else if($(this).attr('name').indexOf('phone') >= 0)
							{
								var val = $(this).val();

								val = val.replace(/[^0-9]/gim,'');

								if(val.length != 11)
								{
									error++;
									$(this).addClass('has-error');
									if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';
								}
								else
									$(this).removeClass('has-error');
							}
							else if($(this).attr('name').indexOf('mail') >= 0)
							{
								var val = $(this).val();

								var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

								if(!re.test(String(val).toLowerCase()))
								{
									error++;
									$(this).addClass('has-error');
									if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';
								}
								else
									$(this).removeClass('has-error');
							}
							else 
							{
								var tagname = $(this).prop("tagName");
								$(this).removeClass('has-error');
								if (tagname == 'SELECT') {
									var select_id = $(this).attr('id') + '_chosen';
									$('#' + select_id + '.chosen-container').removeClass('invalid');
								}
							}


						});

						$('input[name="agree"]',this).each(function()
						{
							if(!$(this).is(":checked"))
							{
								var error_text = '<span class="bg-red font-size-80 text-white d-inline-block px-2 py-1 rounded-3 label-info" style="margin-left: -8px;margin-bottom: 4px;">Установите галочку в этом поле!</span>';

								$(error_text).insertBefore(this);

								// text+= '- <b>Правила и оферту сайта!</b><br />';
								error++;
								$(this).addClass('has-error');
							}
						});

						if (error > 0) {
							// if (text.length) 
							// {
							// 	var html = '';

							// 	html+= '<p class="h1 font-weight-600 mb-4">Произошла ошибка</p>';
							// 	html+= '<div>';
							// 	html+= 		'<p>Введенные вами данные не будут отправлены, так как не все обязательные поля были заполнены:</p><p>' + text + '</p>';
							// 	html+= '</div>';

							// 	// text = '<p class="h1 font-weight-600 mb-4">Произошла ошибка</p><div>Введенные вами данные не будут отправлены, так как не все обязательные поля были заполнены:</p><p>' + text + '</p>';
							// 	$(window).message(html);
							// }

							e.preventDefault();
						} 
						else if(!form.hasClass('no-ajax')) 
						{
							var action = null;

							if ($(this).find('button[type="submit"]').length) action = $(this).find('button[type="submit"]').val();

							if ($('body').hasClass('checkout') || $('body').hasClass('profile_page') || action == 'register' || action == 'remind' || action == 'login' || $('body').hasClass('remind')) action = null;

							var form = $(this);

							if (action) 
							{
								e.preventDefault();

								var query = $(this).serialize();

								query+= '&referer=' + current_url;

								$.ajax({
									type: 'POST',
									method: 'POST',
									cashe: false,
									url: baseurl,
									data: { ajax: true, option: action, query: query }
								}).done(function (msg) {
									form.find("input[type=text], textarea").val("");

									var text = msg;

									if(!msg)
									{
										var html = '';

										html+= '<div class="modal-header">';
										html+= '	<p class="text-uppercase ls-05 mb-4 font-weight-medium text-warning text-center w-100">Произошла ошибка</p>';
										html+= '</div>';
										html+= '<div class="modal-body">';
										html+= 		'<p>Ваше сообщение не было отправлено. Попробуйте сделать это позже.</p>';
										html+= '</div>';
										html+= '<a href="#" class="btn btn-default" data-dismiss="modal">закрыть</a>';

										text = html;
									}
									else if(msg && msg == 1)
									{
										$('.modal.fade.show').each(function () 
										{
											var id = $(this).attr('id');
										
											$('#' + id).modal('hide');
										});

										var html = '';

										html+= '<p class="h1 font-weight-600 mb-4">Спасибо!</p>';
										html+= '<div>';
										html+= 		'<p>В ближайшее время с Вами свяжется наш менеджер для подтверждения заказа. </p>';
										html+= '</div>';

										text = html;
									}

									var message_text = $.trim(text);

									// if(message_text.indexOf('t-20') < 0)
									// 	message_text = '<p class="h1 font-weight-600 mb-4">Сообщение</b></p>' + message_text;

									$(window).message(message_text);

								});
							}
						}
					});
				});



				$.getScript(baseurl + 'scripts/jquery.fancybox.min.js', function(){
					$('.fancybox').fancybox();
				});


				
				$('body').find('.svg').createSVG();



				$.getScript(baseurl + 'scripts/owl.carousel.min.js', function()
				{
					$('[data-carousel]').each(function(index)
					{
						try {
							$(this).owlCarouselStart(index);
						} catch (error) {
							console.log(error);
						}
					});

					$.getScript(baseurl + 'scripts/TweenMax.min.js', function()
					{
						console.log($('body').height());
						
						if($('body').height() >= 1800)
						{
							console.log($('body').height());

							$('body').append('<div class="cloud cloud-2" style="top: ' + $('body').height() + 'px;"></div>');
						}

						if($('body').height() < 1800)
						{
							$('.airplane').addClass('d-none');
						}

						$(document).mousemove(function(e) 
						{
							$(".cloud-1").parallax(-30, e);
							$(".cloud-2").parallax(10, e);
						});
					});
				});

				if($('.phone-ring').length)
				{
					$('.phone-ring').addClass('animated').addClass('shake');

					setInterval(function()
					{
						$('.phone-ring')
						.removeClass('animated')
						.removeClass('shake');

						setTimeout(function()
						{
							$('.phone-ring').addClass('animated').addClass('shake');
						}, 1000);
						// .addClass('animated')
						// .addClass('heartBeat');
					}, 5000);
				}

				$('.btn-inline').each(function()
				{
					$(this).attr('data-title',$(this).text());
				});

				$('.btn:not(.btn-inline)').each(function()
				{
					// $(this).addClass('animated');
				});

				$('.btn:not(.btn-inline)').hover(
					function() 
					{
						$(this).addClass('animated').addClass('heartBeat'); // Добавляем класс bounce
					},
					function() 
					{
						$(this).removeClass('animated').removeClass('heartBeat'); // Убираем класс
					}
				);

				$('.main-menu .nav-item').hover(
					function() 
					{
						$(this).find('ul').addClass('animated').addClass('flipInX'); // Добавляем класс bounce
					},
					function() 
					{
						$(this).find('ul').removeClass('animated').removeClass('flipInX'); // Убираем класс
					}
				);

				$('.open-list').hover(
					function() 
					{
						$(this).find('> *:first-child + *').addClass('animated').addClass('flipInX'); // Добавляем класс bounce
					},
					function() 
					{
						$(this).find('> *:first-child + *').removeClass('animated').removeClass('flipInX'); // Убираем класс
					}
				);
				
				if($('.custom-scroll').length)
				{
					$.getScript(baseurl + 'scripts/jquery.mCustomScrollbar.js', function()
					{
						$(".custom-scroll").mCustomScrollbar();
					});
				}

				$('.tab-item').click(function(e)
				{
					e.preventDefault();

					var href = $(this).attr('href');

					$(this).parent().find('.tab-item.bg-yellow').removeClass('bg-yellow').removeClass('px-2').removeClass('py-1').removeClass('text-default').removeClass('rounded-2');
					$(this).addClass('bg-yellow').addClass('px-2').addClass('py-1').addClass('text-default').addClass('rounded-2');

					$('body').find('.tab' + href).parent().find('.tab').addClass('d-none');
					$('body').find('.tab' + href).removeClass('d-none');
				});
				

				if($('.map-container').length)
				{
					$.getScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', function()
					{
						$('.map-container').each(function(index)
						{
							var id = 'map' + index;

							$(this).attr('id',id);

							ymaps.ready(init);
							var myMap, 
							myPlacemark;

							var coords = map_coords;
							var coords_center = [coords[0],(parseFloat(coords[1]) - parseFloat(0.005))];

							console.log(coords);
							console.log(coords_center);

							function init ()
							{
								var zoomControl = new ymaps.control.ZoomControl(
								{
								    options: 
								    {
								        size: "small",
								        position:
								        {
								        	left: 'auto',
								        	right: 10,
								        	top: 108
								        }
								    }
								});
								myMap = new ymaps.Map(id,
								{
									center: coords_center,
									zoom: 16,
									controls: ["fullscreenControl"]
								});
								myPlacemark = new ymaps.Placemark
								(
									coords,
									{
										content: map_content, 
										balloonContent: map_balloonContent
									}
								);
								myMap.geoObjects.add(myPlacemark);
								myMap.behaviors.disable("scrollZoom");
								myMap.controls.add(zoomControl);
							}
						});
					});
				}
				$(window).scroll(function()
				{
					if($('#slider').length > 0)
					{
						if($(document).scrollTop() > 0)
							$('.head.fixed-top').addClass('show');
						else
							$('.head.fixed-top').removeClass('show');
					}

					if($(document).scrollTop() > 600)
					{
						$('body').addClass('airplane-fly');
					}
				});
			// }
		});
	// });

	if($('.ajax-content-chat').length)
	{
		$('body').on('click','.open_dialog_chat',function(e)
		{
			e.preventDefault();
			var user_id = $(this).attr('rel3');
			var manager_id = $(this).attr('rel');
			var order_id = $(this).attr('rel2');

			$('.open_dialog_chat').removeClass('bg-blue-light');
			$(this).addClass('bg-blue-light');

			$.ajax(
			{
				type:'POST',
				method:'POST',
				cashe: false,
				url: baseurl + 'profile',
				data:{ajax:true,option:'open_dialog',user_id: user_id,manager_id: manager_id,order_id: order_id}
			})
			.done(function(msg)
			{
				$('.ajax-content-chat').html(msg);
				$(".custom-scroll:not(.mCustomScrollbar)")
				.mCustomScrollbar()
				.mCustomScrollbar('scrollTo','bottom');
			});
		});


		$('body').on('submit', 'form.send_dialog_chat', function (e) 
		{
			e.preventDefault();
			$.ajax(
			{
				type:'POST',
				method:'POST',
				cashe: false,
				url: baseurl + 'profile',
				data:{ajax:true,option:'send_dialog',query: $(this).serialize()}
			})
			.done(function(msg)
			{
				msg = msg.replace(/\r?\n/g, "");

				$('.chat-messages-list .mCSB_container > div').append(msg);

				$(".custom-scroll.chat-messages-list")
				.mCustomScrollbar('scrollTo','bottom');

				$('form.send_dialog_chat').find('textarea').val('');
				$('form.send_dialog_chat').find('.files-container').empty();

				console.log($('form.send_dialog_chat').find('textarea').length);
			});
		});

		setInterval(function() 
		{
			$.ajax(
			{
				type:'POST',
				method:'POST',
				cashe: false,
				url: baseurl + 'profile',
				data:{ajax:true,option:'get_view_dialog',query: $('form.send_dialog_chat').serialize()}
			})
			.done(function(msg)
			{
				if(!msg)
					return false;

				msg = msg.replace(/\r?\n/g, "");

				$('.chat-messages-list .mCSB_container > div').append(msg);

				var pos = $('.chat-messages-list').find('.mCSB_dragger').position().top + $('.chat-messages-list').find('.mCSB_dragger').height();
				var height = $('.chat-messages-list').find('.mCSB_draggerContainer').height();

				var def = height - pos;

				console.log(height);
				console.log(pos);

				// $(".custom-scroll.chat-messages-list").mCustomScrollbar("update");

				// console.log($(".custom-scroll.chat-messages-list").mcs.topPct);

				if(def < 100)
				{
					$(".custom-scroll.chat-messages-list")
					.mCustomScrollbar('scrollTo','bottom');
				}
				
			});
			// console.log('Проверка новых сообщений');
		}, 3000);
	}
	
});


// WEBPACK FOOTER //
// ../scripts/sources/script.js